import { Component, OnInit ,ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from 'src/app/_models';
import { TicketsService } from 'src/app/_services/tickets.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-all-tickets',
  templateUrl: './all-tickets.component.html',
  styleUrls: ['./all-tickets.component.css']
})
export class AllTicketsComponent implements OnInit {

  displayedColumns: string[] = [ 'no','name', 'assignedTo', 'startDate','status'];
  //dataSource = ELEMENT_DATA;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  total : number;
  loading = true;
  error = '';
  dataSource;
  arr;
  title = 'materialApp'; 
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public userId :  string



  constructor(private ticketservice : TicketsService) { 

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId =  this.currentUserSubject.value.userId;


    ticketservice.getTicketList().subscribe(
      res => {        
          // this.dataSource = <any>res;
          // this.total =  this.dataSource.length;
          this.arr = res  
          this.arr.forEach((item,index) => {
            item.index = index
              });
          this.dataSource = new MatTableDataSource(this.arr);  
          this.dataSource.paginator = this.paginator;    
          this.total =  this.arr.length; 
          this.loading = false;
      },
      error => {  
        this.error = error;
        this.loading = false;
    });
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;    

  }

}
